import React, { useState, useEffect } from "react";

import styles from "./style.module.scss";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import {
  Button,
  DataTable,
  SwitchButton,
} from "@learningblocks/shared-components";
import cn from "./style.module.scss";

export function DataTableRandomiser(props) {
  const [callToAction, setCallToAction] = useState(true);
  const [toggleState, setToggleState] = useState(false);
  const [currentDataset, setCurrentDataset] = useState(0);
  const data = [...props.table.data[currentDataset]];

  useEffect(() => {
    if (toggleState) {
      setCurrentDataset(1);
    } else {
      setCurrentDataset(0);
    }
  }, [toggleState]);

  useEffect(() => {
    if (props.id == 81) {
      for (let i = 1; i < 7; i++) {
        data[i][0].text = props.actualResults.tubeBeakerNumber[i - 1];
        data[i][2].text =
          props.actualResults.tubeWeightsPreDialysis[i - 1] === -1
            ? ""
            : props.actualResults.tubeWeightsPreDialysis[i - 1].toString();
        data[i][3].text =
          props.actualResults.tubeWeightsPostDialysis[i - 1] === -1
            ? ""
            : props.actualResults.tubeWeightsPostDialysis[i - 1].toString();
      }
    }

    //To show table by default, add "Don't Show" as call to action text
    if (props.callToAction == "Don't Show") {
      setCallToAction(false);
    }
  }, []);

  return (
    <div className={styles.dataTableRandomiser}>
      <div className={styles.callToActionWrapper}>
        {callToAction ? (
          <div className={styles.callToAction}>
            <Button onClick={() => setCallToAction(!callToAction)}>
              {props.callToAction}
            </Button>
          </div>
        ) : null}
        <DataTable
          data={data}
          indices={props.table.indices[currentDataset]}
          className={styles.dataTable}
        />
        {props?.controls?.toggles.length > 0 ? (
          <div className={styles.switchBlock}>
            {props?.controls?.toggles.map((toggle) => (
              <SwitchButton
                value={toggle.value}
                checked={toggleState}
                name={toggle.name}
                onChange={() => {
                  setToggleState(!toggleState);
                }}
                label={toggle.label}
                ariaLabel={toggle.ariaLabel}
              />
            ))}
          </div>
        ) : null}
      </div>
      {props.table.caption ? (
        <figcaption className={cn.figcaption}>
          <RichText {...props.table.caption} />
        </figcaption>
      ) : null}
    </div>
  );
}

DataTableRandomiser.propTypes = {};
